<template>
  <CourseCheckout @close="emit('close')" />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import { AuthenticatedCart } from '@/munio/api/ShopCheckout'

const CourseCheckout = defineAsyncComponent(() => import('./CourseCheckout.vue'))

const props = defineProps<{
  cart: AuthenticatedCart
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()

window.Munio.state.cart = props.cart
</script>
